<template>
  <div class="a-rank">
    <img v-if="banner.imgurl" :src="banner.imgurl" />
    <div class="container">
      <div class="title" v-if="!banner.imgurl">{{ name }}</div>
      <div class="input-area">
        <div class="left">
          <div class="input">
            <van-field v-model="idno" :placeholder="`请输入${sname}搜索`" />
          </div>
        </div>
        <div class="right">
          <div class="item" @click="rank_serch">
            <div class="icon">
              <img src="~/assets/img/serch.png" />
            </div>
            <div class="label">搜索</div>
          </div>
          <div class="item" @click="show = true">
            <div class="icon">
              <img src="~/assets/img/tab.png" />
            </div>
            <div class="label">切换组别</div>
          </div>
        </div>
      </div>
      <!-- <div class="time" v-if="update_time">成绩更新时间：{{ update_time }}</div> -->
      <div v-for="(item, i) in rank_list" :key="i">
        <div class="g-title">{{ item.name }}</div>
        <div class="table">
          <div class="con">
            <a-table rowKey="id" :pagination="false" :columns="item.columns" :dataSource="item.list" size="middle" :scroll="{ x: true }">
              <template slot="rank" slot-scope="text">
                <span v-if="text == 1">
                  <img class="i-icon" src="~/assets/img/first.png" />
                </span>
                <span v-else-if="text == 2">
                  <img class="i-icon" src="~/assets/img/second.png" />
                </span>
                <span v-else-if="text == 3">
                  <img class="i-icon" src="~/assets/img/thired.png" />
                </span>
                <span v-else>{{ text }}</span>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <van-popup position="right" :style="{ width: '70%' }" v-model="show">
      <div class="popup">
        <div class="item" v-for="item in g_list" :key="item.id">
          <div class="i-title">{{ item.name }}</div>
          <div
            class="i-item"
            @click="group_change(row, item)"
            :class="item_id == row.id ? 'active' : ''"
            v-for="row in item.child_data"
            :key="row.id"
          >
            {{ row.name }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  computed: {
    sname() {
      if(this.type == 1) {
        return '参赛号码'
      }

      return '证件号码'     
    },
  },
  data() {
    return {
      show: false,
      update_time: '',
      rank_list: [],
      gid: '',
      gname: '',
      g_list: [],
      item_id: '',
      item_name: '',
      item_list: [],
      current_group: {},
      matchid: this.$route.params.matchid,
      type: this.$route.params.type||0,
      banner: {},
      name: '',
      idno: '',
    }
  },
  mounted() {
    this.get_group()

    let hfz = document.documentElement.clientWidth / 2

    document.documentElement.style.fontSize = (hfz > 100 ? hfz : 100) + 'px'
  },
  methods: {
    rank_serch() {
      if (!this.idno) {
        this.get_rank_list()
        return
      }
      const query = {
        matchid: this.matchid,
        idno: this.idno,
      }
      this.$api.match.rankSearch(query).then((r) => {
        if (!r.data.list.length) {
          this.$toast('暂无数据。')
          this.idno = ''
          return
        }

        const rank_list = []

        r.data.list.forEach((row) => {
          const list = [row]
          let columns = []
          if (row.result_json_head) {
            columns = row.result_json_head.map((item, i) => {
              return {
                title: item,
                dataIndex: 'result[' + i + ']',
              }
            })
          }

          columns = [
            {
              title: '排名',
              dataIndex: 'rank',
              align: 'center',
              scopedSlots: { customRender: 'rank' },
            },
            {
              title: '姓名',
              dataIndex: 'name',
            },
          ].concat(columns)

          const obj = {
            name: row.group_pid_name + ' ' + row.group_name,
            list,
            columns,
          }

          rank_list.push(obj)

          this.rank_list = rank_list
        })
      })
    },
    group_change(item, group) {
      this.gid = group.id
      this.gname = group.name
      this.item_id = item.id
      this.item_name = item.name
      this.idno = ''

      this.get_rank_list()

      this.show = false
    },
    get_rank_list() {
      this.team = []
      const query = {
        matchid: this.matchid,
        groupid: this.item_id,
      }
      this.$api.match.rankList(query).then((r) => {
        this.update_time = r.data.update_time

        let columns = r.data.result_head.map((row, i) => {
          return {
            title: row,
            dataIndex: 'result[' + i + ']',
          }
        })

        columns = [
          {
            title: '排名',
            dataIndex: 'rank',
            align: 'center',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '姓名',
            dataIndex: 'name',
          },
        ].concat(columns)

        const rank_list = [
          {
            name: this.gname + ' ' + this.item_name,
            list: r.data.list,
            update_time: r.data.update_time,
            columns,
          },
        ]

        this.rank_list = rank_list
      })
    },
    get_group() {
      this.$api.match.groupList({ matchid: this.matchid, pid: 0 })
        .then((r) => {
          if (r.status == 200) {
            const list = []
            r.data.data.forEach((row) => {
              // if (row.type == 1) {
              list.push(row)
              // }
            })
            this.banner = r.data.banner
            this.name = r.data.name
            this.g_list = list
            this.current_group = list[0]
            this.gid = list[0].id
            this.gname = list[0].name
            this.item_list = list[0].child_data
            this.item_id = list[0].child_data[0].id
            this.item_name = list[0].child_data[0].name
          }
        })
        .then((r) => {
          this.get_rank_list()
        })
    },
  },
}
</script>

<style>
.ant-table th,
.ant-table td {
  white-space: nowrap;
}
li.ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-active {
  background: rgba(241, 90, 36, 0.07);
}
</style>

<style lang="less" scoped>
.a-rank {
  > img {
    width: 100%;
    padding-bottom: 16px;
  }
  .container {
    // display: flex;
    // justify-content: center;
    background: #fefefe;
    padding: 0 15px;
  }

  .i-icon {
    width: 18px;
    height: 24px;
  }

  .time {
    font-size: 0.075rem;
    color: #ccc;
    text-align: center;
    padding-bottom: 0.08rem;
    margin: 0 -15px;
  }

  .g-title {
    font-size: 0.08rem;
    font-weight: bold;
    margin-bottom: 0.08rem;
    margin-top: 0.08rem;
    position: relative;
    padding-left: 0.1rem;
    &::before {
      content: ' ';
      display: block;
      width: 0.09rem;
      height: 0.09rem;
      background: #f15a24;
      position: absolute;
      top: 50%;
      left: -15px;
      transform: translateY(-50%);
    }
  }

  .table {
    padding: 6px 4px;
    border-radius: 24px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
    .con {
      border-radius: 24px;
      overflow: hidden;
    }
  }

  .popup {
    box-sizing: border-box;
    padding: 30px 15px 120px;
    box-sizing: border-box;
    min-height: 100vh;
    .item {
      & + .item {
        margin-top: 18px;
      }
      .i-title {
        font-size: 0.08rem;
        font-weight: bold;
        padding-left: 8px;
        margin-bottom: 0.06rem;
        position: relative;
        &::before {
          position: absolute;
          content: ' ';
          display: block;
          width: 6px;
          height: 13px;
          background: #f15a24;
          left: -6px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .i-item {
        margin-right: 8px;
        display: inline-block;
        font-size: 0.07rem;
        padding: 6px 12px;
        border-radius: 8px;
        background: #f4f4f4;
        &.active {
          color: #fff;
          background: #f15a24;
        }
        & + .i-item {
          margin-top: 8px;
        }
      }
    }
  }

  > div {
    width: 100%;
  }

  .title {
    width: 100%;
    padding: 0.06rem 0;
    font-size: 0.1rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.02rem;
  }

  .input-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.05rem solid #f4f4f4;
    margin: 0 -15px 0.06rem;
    padding: 0 15px 0.08rem;
    .left {
      .input {
        width: 1.25rem;
        height: 0.225rem;
        border-radius: 0.1rem;
        background: #f4f4f4;
        /deep/ .van-cell.van-field {
          background: transparent;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        & + .item {
          margin-left: 0.1rem;
        }
        .icon {
          width: 0.1rem;
          height: 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .label {
          margin-top: 0.02rem;
          font-size: 0.05rem;
        }
      }
    }
  }
}
</style>

<style scoped>
.rank >>> .ant-table {
  font-size: 20px;
  background: #fff;
}

.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>
